import { default as Collapse } from 'antd/es/collapse';
import { faqItems } from './FaqText';

import { Link } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollToTop';
import { enhanceLinkWithToken } from '../utils/enhanceLinkWithToken';

export function SupportPage() {
  return (
    <>
      <div className="raw m-8 flex flex-col items-center">
        <div className="flex flex-col gap-6 lg:w-3/5">
          <p className="text-4xl font-bold text-inpay-dark-green-1000">
            API Support
          </p>
          <p>
            For help with the Inpay API, answers to common questions, or any
            additional technical support you need.
          </p>
          <h1>Frequently Asked Questions</h1>
          <Collapse
            className="hover:cursor-pointer"
            expandIconPosition="end"
            ghost
            items={faqItems}
          />

          <div className="flex flex-row flex-wrap items-center justify-between rounded-xl bg-inpay-gray-primary-200 p-8 dark:bg-black lg:flex-nowrap">
            <img src="./support-icon.svg" height={50} />
            <p>For existing customers, login to our support area.</p>
            <a
              href="https://www.inpay.com/contact-us/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="super-round-inpay bg-inpay-green-secondary-light-1000 text-black hover:bg-inpay-green-secondary-light-800">
                Request support
              </button>{' '}
            </a>
          </div>
        </div>
      </div>

      <div className="flex h-[30%] flex-col items-center justify-center gap-6 bg-[url('/support-grad2.jpg')]">
        <div className="flex flex-col items-center gap-6">
          <p className="text-4xl font-bold text-inpay-dark-green-1000 dark:text-black">
            Start with Inpay today
          </p>

          <p className="text-inpay-dark-green-1000 dark:text-black">
            Contact our sales team if you want to hear more about the Inpay API
            or Batch payments.
          </p>

          <div className="flex w-full flex-row justify-center gap-4 dark:text-black">
            <a
              href="https://www.inpay.com/contact-us/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="super-round-inpay border-2 border-inpay-dark-green-1000 text-black">
                Request a demo
              </button>
            </a>

            <Link
              to={enhanceLinkWithToken('/reference/getting-started')}
              onClick={scrollToTop}
            >
              <button className="super-round-inpay bg-inpay-green-secondary-light-1000 text-black hover:bg-inpay-green-secondary-light-800">
                Explore our docs
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
